import { PiArrowUpRightLight } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import styles from './ButtonLink.module.css';

/**
 * Pill CTA with a nested arrow. Internal paths use <Link>, anything else a plain <a>.
 * variant: 'solid' | 'outline' | 'text'
 */
export function ButtonLink({ to, variant = 'solid', className = '', children, ...rest }) {
  const isInternal = to.startsWith('/') && !to.startsWith('//');
  const Tag = isInternal ? Link : 'a';
  const target = isInternal ? { to } : { href: to };

  return (
    <Tag {...target} className={`${styles.button} ${styles[variant]} ${className}`} {...rest}>
      <span>{children}</span>
      <span className={styles.icon} aria-hidden="true">
        <PiArrowUpRightLight />
      </span>
    </Tag>
  );
}
